import React, { useState, useEffect } from "react";
import config from "../../config";
import "./OnboardingFilter.css";

export default function OnboardingFilter({
  open,
  onClose,
  onApply,
  onClear,
  jobStatusOptions = [],
  initialValues,
}) {
  const [jobRoles, setJobRoles] = useState([]);
  const [userDetails, setUserDetails] = useState({ token: "", orgId: "" });

  const [form, setForm] = useState({
    gender: "",
    jobRole: "",
    jobStatus: "",
    sortOrder: "",
  });

  // Get token and orgId
  useEffect(() => {
    const token = localStorage.getItem("Authorization") || "";
    const orgId = localStorage.getItem("orgId") || "";
    setUserDetails({ token, orgId });
  }, [open]);

  // Sync initial filter values
  useEffect(() => {
    if (open && initialValues) {
      setForm({
        gender: initialValues.gender || "",
        jobRole: initialValues.jobRole || "",
        jobStatus: initialValues.jobStatus || "",
        sortOrder: initialValues.sortOrder || "",
      });
    }
  }, [open, initialValues]);

  // Fetch Job Roles
  useEffect(() => {
    if (open && userDetails.token && userDetails.orgId) {
      fetchJobRoles();
    }
  }, [open, userDetails.token, userDetails.orgId]);


  
  const fetchJobRoles = async () => {
    try {
      const url = `${config.API_BASE_URL}${config.VIEW_CLIENT_CONFIG_ENDPOINT}${userDetails.orgId}?configType=JobRole`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${userDetails.token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) throw new Error("Failed to fetch job roles");

      const data = await response.json();

      const activeItems = (Array.isArray(data) ? data : []).filter(
        (item) => item && item.isActive
      );

      const formatted = activeItems
        .map((item) => ({
          value:
            typeof item.values === "string"
              ? item.values.trim()
              : item.values,
          label:
            typeof item.values === "string"
              ? item.values.trim()
              : item.values,
        }))
        .filter((item) => item.value);

      setJobRoles(formatted);
    } catch (error) {
      console.error("Job Role API error:", error);
      setJobRoles([]);
    }
  };

  if (!open) return null;

  const stop = (e) => e.stopPropagation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleClear = () => {
    const cleared = {
      gender: "",
      jobRole: "",
      jobStatus: "",
      sortOrder: "",
    };

    setForm(cleared);

    if (onClear) onClear();
    if (onClose) onClose();
  };

  const handleApply = () => {
    if (onApply) onApply(form);
    if (onClose) onClose();
  };

const renderOptions = (options) => (
  <>
    <option value="">Select</option>
    {options.map((o, index) => (
      <option key={index} value={o.value}>
        {o.label}
      </option>
    ))}
  </>
);

  return (
    <div className="onb-filter-overlay" onClick={onClose}>
      <div
        className="onb-filter-modal"
        style={{ marginLeft: "60%" }}
        onClick={stop}
      >
        <div className="onb-filter-header">Filter</div>

        <div className="onb-filter-body">
          {/* Gender */}
          <label className="onb-filter-label">Gender</label>
          <select
            name="gender"
            className="onb-filter-select"
            value={form.gender}
            onChange={handleChange}
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>

          {/* Job Role */}
          <label className="onb-filter-label">Job Role</label>
          <select
            name="jobRole"
            className="onb-filter-select"
            value={form.jobRole}
            onChange={handleChange}
          >
            {renderOptions(jobRoles)}
          </select>

          {/* Job Status */}
          <label className="onb-filter-label">Job Status</label>
         <select
  name="jobStatus"
  className="onb-filter-select"
  value={form.jobStatus}
  onChange={handleChange}
>
  <option value="">Select Status</option>
  <option value="Onboarded">Onboarded</option>
  <option value="Canceled">Canceled</option>
</select>

          {/* Sort Order */}
          <label className="onb-filter-label">Sort By</label>
          <select
            name="sortOrder"
            className="onb-filter-select"
            value={form.sortOrder}
            onChange={handleChange}
          >
            <option value="">Select</option>
            <option value="DESC">Newest</option>
            <option value="ASC">Oldest</option>
          </select>
        </div>

        <div className="onb-filter-actions">
          <button className="onb-btn onb-btn-clear" onClick={handleClear}>
            Clear
          </button>

          <button className="onb-btn onb-btn-apply" onClick={handleApply}>
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}